import * as z from 'zod';
import { EntityId, Tag } from '../base-schemas';
export const LockProvider = z.enum(['igloo', 'tally']);
/** Visningsnamn och ikon per låsleverantör. */
export const lockProviders = {
    igloo: { label: 'Igloo', icon: 'mdi-lock' },
    tally: { label: 'Tally', icon: 'mdi-dialpad' }
};
/**
 * Låset som är kopplat till (eller kan kopplas till) en produkt eller ett objekt: ett Igloo-lås eller en Tally-tjänst.
 * Motsvarar serverns LockData. Varje produkt och objekt har högst ett lås.
 * Inte samma sak som en access grant, som är koden som utfärdas för en reservation.
 */
export const LockData = z.object({
    _tag: Tag('LockData'),
    provider: LockProvider,
    id: EntityId,
    external_id: z.string(),
    name: z.string(),
    property_name: z.string().nullable()
});
/** Unik nyckel för ett lås, eftersom id bara är unikt per leverantör. */
export const lockKey = (lock) => lock ? `${lock.provider}:${lock.id}` : null;
export const lockLabel = (lock) => lock.property_name ? `${lock.property_name} / ${lock.name}` : lock.name;
